/**
 * Reusable Driver Instructions Field Component
 * Can be used in both DetailsStep and RmcOrderEdit with consistent styling and behavior
 */

import {useDriverInstructions} from '@hconnect/tuc-processes/fields/textField'
import {ControlledTextarea} from '@hm/fundamental'
import React from 'react'
import {useTranslation} from 'react-i18next'

/**
 * Props for the Driver Instructions Field component
 */
interface DriverInstructionsFieldProps {}

/**
 * Reusable Driver Instructions Field component with consistent styling
 */
export const DriverInstructionsField: React.FC<DriverInstructionsFieldProps> = () => {
  const {t} = useTranslation()
  const {driverInstructions, setDriverInstructions, error} = useDriverInstructions()

  const placeholder = t(
    'orderIntake.rmc.steps.shared.driverInstructionsPlaceholder',
    'Add an instruction notes to driver ...'
  )

  const handleDriverInstructionsChange = React.useCallback(
    (event: React.ChangeEvent<HTMLTextAreaElement>) => {
      const newValue = event.target.value
      setDriverInstructions(newValue)
    },
    [setDriverInstructions]
  )

  return (
    <ControlledTextarea
      name={t('orderIntake.rmc.steps.shared.driverInstructionsLabel', 'Driver instructions')}
      label={t('orderIntake.rmc.steps.shared.driverInstructionsLabel', 'Driver instructions')}
      value={driverInstructions}
      onChange={handleDriverInstructionsChange}
      isDisabled={false}
      data-test-id="driver-instructions-input"
      state={error ? 'error' : undefined}
      hint={error ? error.message : placeholder}
    />
  )
}
